import axios from "axios";
import { errorParser } from "../../helpers/errorHelper";
import { farmageo_api } from "../../config";

import { ALERT } from "./alertActions";
import store from "../store/index";

import { GET_USUARIO } from "./userActions";

export const RESET_ERROR = () => {
  return (dispatch) => {
    dispatch({ type: "RESET_ERROR" });
  };
};

export const CHECK_TOKEN = async () => {
  return (dispatch) =>
    axios.post(farmageo_api + "/checkToken").then((res) => {
      if (res.status > 300) {
        dispatch(LOGOUT());
      }
      return res;
    });
};

export const TRYREGISTER = (body) => {
  return (dispatch) => {
    axios
      .post(farmageo_api + "/farmacias/register-try", {
        email: body,
        destinatario: "soporte@farmageo.com.ar",
        version: "2",
      })
      .then((r) => alert(JSON.stringify(r.data)));
  };
};

export const LOGIN = (user, password) => {
  return (dispatch) => {
    axios
      .post(farmageo_api + "/users/loginwp", {
        username: user,
        password: password,
      })
      .then(function (response) {
        if (response.status == 500) {
          ALERT(
            "Error",
            "Usuario y/o contraseña incorrectos",
            "error",
            "OK"
          ).then(() => {
            store.dispatch(LOGOUT());
            window.location.replace(`${process.env.PUBLIC_URL}/#/login`);
          });
        }
        if (parseInt(response.status) < 300) {
          dispatch({ type: "authenticated", payload: user });
          dispatch({ type: "LOGIN_OK", payload: response.data });
          dispatch({ type: "GET_USER_ROLES" });

          localStorage.setItem("login", JSON.stringify(response.data));
          localStorage.setItem("authenticated", JSON.stringify(true));
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("refreshToken", response.refreshToken);
          localStorage.setItem("loginId", user);

          // hasta que resuelva lo del token
          localStorage.setItem("user", user);
          localStorage.setItem("pass", password);

          window.location.replace(`${process.env.PUBLIC_URL}/#/pantalla/INICIO`);
        }
      })
      .catch(function (error) {
        ALERT(
          "Error",
          "Usuario y/o contraseña incorrectos",
          "error",
          "OK"
        ).then(() => {
          store.dispatch(LOGOUT());
        });
        dispatch(LOGOUT());
        dispatch({ type: "LOGIN_ERROR", error: errorParser(error) });
        return;
      });
  };
};


export const LOGOUT = () => {
  return (dispatch) => {
    localStorage.removeItem("login");
    localStorage.removeItem("authenticated");
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("loginId");
    localStorage.removeItem("user");
    localStorage.removeItem("pass");
    dispatch({ type: "LOGOUT" });
    axios.post(farmageo_api+"/logout")
  };
};

//TODO: AQUI SE DEBERIA CONSULTAR OTRA VEZ A LA API PARA PEDIS LOS ROLES: ARREGLAR ESTO PRONTO
export const GET_USER_ROLES = () => {
  return (dispatch) => {
    dispatch({ type: "GET_USER_ROLES" });
  };
};

export const IS_USER = () => {
  return (dispatch) => {
    dispatch({ type: "ISUSER" });
  };
};

export const GET_SESSION = () => {
  return async (dispatch) => {
    var authenticated = localStorage.getItem("authenticated");
    var user = localStorage.getItem("user");
    var pass = localStorage.getItem("pass");

    if (authenticated) {
      dispatch({
        type: "authenticated",
        payload: user,
      });
      dispatch(LOGIN(user, pass));
    }
  };
};
